import wttqQGold from "../assets/wttq-q-gold.png";
import aboutTeam from "../assets/about-team.png";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1561501900-3701fa6a0864?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB0cmF2ZWwlMjBzdW5zZXQlMjByZXNvcnR8ZW58MHx8fHwxNzgyNTU4MTM0fDA&ixlib=rb-4.1.0&q=85",
  about: aboutTeam,
  wttq: wttqQGold,
  travelAwards: "https://images.unsplash.com/photo-1532984601283-d68a3ee3e51f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxTeWRuZXklMjBBdXN0cmFsaWElMjBPcGVyYSUyMEhvdXNlJTIwSGFyYm91ciUyMEJyaWRnZXxlbnwwfHx8fDE3ODI2MzUzNzd8MA&ixlib=rb-4.1.0&q=85",
  twbl: "https://images.unsplash.com/photo-1710297148196-cafed28c81c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwbHV4dXJ5JTIwaG90ZWwlMjBsb2JieSUyMFRoYWlsYW5kfGVufDB8fHx8MTc4MjYzMzg4MXww&ixlib=rb-4.1.0&q=85",
  alfredWine: "https://images.unsplash.com/photo-1553361371-9b22f78e8b1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZWQlMjB3aW5lJTIwZ2xhc3MlMjB0YXN0aW5nfGVufDB8fHx8MTc4MjU1OTQ0OHww&ixlib=rb-4.1.0&q=85",
  vineyardsWine: "https://images.unsplash.com/photo-1768148809296-dbaf6d21d23b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHx2aW5leWFyZCUyMGxhbmRzY2FwZSUyMHJvd3MlMjBncmVlbiUyMGhpbGxzfGVufDB8fHx8MTc4MjYzMzg1Nnww&ixlib=rb-4.1.0&q=85",
  wttqAlliance: "https://images.unsplash.com/photo-1451976426598-a7593bd6d0b2?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
};

export const SUBBRANDS = [
  {
    id: "wttq",
    slug: "wttq-certifications",
    name: "WTTQ Certifications",
    category: "Certifications",
    tagline: "World Travel & Tourism Quality",
    short: "Internationally recognized certification programs that validate quality, competence, and professional standards across the travel and tourism industry.",
    url: "https://wttq.org",
    urlLabel: "wttq.org",
    image: IMAGES.wttq,
  },
  {
    id: "travel-awards",
    slug: "travel-awards",
    name: "Travel Awards",
    category: "Awards",
    tagline: "Celebrating Global Travel Excellence",
    short: "A prestigious awards program honoring outstanding achievement, innovation, and service excellence among destinations, operators, and travel professionals worldwide.",
    url: "https://travel-awards.org",
    urlLabel: "travel-awards.org",
    image: IMAGES.travelAwards,
  },
  {
    id: "twbl",
    slug: "the-worlds-best-luxury",
    name: "TWBL Awards",
    category: "Awards",
    tagline: "The World's Best Luxury",
    short: "The definitive benchmark for luxury hospitality, recognizing the finest hotels, resorts, and experiences that define the pinnacle of refined travel.",
    url: "https://theworldsbestluxury.com",
    urlLabel: "TheWorldsBestLuxury.com",
    image: IMAGES.twbl,
  },
  {
    id: "alfred-wine",
    slug: "alfred-wine-ratings",
    name: "Alfred Wine Ratings",
    category: "Ratings",
    tagline: "Independent Wine Excellence",
    short: "A trusted, independent rating authority evaluating wines by quality, character, and craftsmanship to guide enthusiasts and the trade toward true distinction.",
    url: "https://alfredwine.com",
    urlLabel: "alfredwine.com",
    image: IMAGES.alfredWine,
  },
  {
    id: "vineyards-wine",
    slug: "vineyards-and-wine",
    name: "Vineyards & Wine",
    category: "Ratings",
    tagline: "Celebrating the World's Vineyards",
    short: "A dedicated platform honoring the finest vineyards, wineries, and wine experiences, connecting discerning travelers with the heritage and artistry of the vine.",
    url: "https://vineyardswine.com",
    urlLabel: "vineyardswine.com",
    image: IMAGES.vineyardsWine,
  },
  {
    id: "wttq-alliance",
    slug: "wttq-alliance",
    name: "WTTQ Alliance",
    category: "Partnerships",
    tagline: "Leading Sustainable Hospitality",
    short: "WTTQ Alliance identifies those hospitality businesses leading the way in making the world travel & tourism industry a world class sustainable business.",
    url: "https://wttq.org/alliance",
    urlLabel: "wttq.org/alliance",
    image: IMAGES.wttqAlliance,
  },
];

export const BRAND_CATEGORIES = [
  { name: "Certifications", desc: "Internationally recognized quality and professional competence certification." },
  { name: "Awards", desc: "Honoring excellence across destinations, hospitality, and luxury travel." },
  { name: "Ratings", desc: "Independent ratings celebrating the finest in wine and vineyards." },
  { name: "Partnerships", desc: "Alliances driving a world-class, sustainable travel & tourism industry." },
];

export const SUBBRAND_DETAILS = {
  "wttq-certifications": {
    ...SUBBRANDS[0],
    intro: "WTTQ Certifications set the global standard for quality and professional competence in travel and tourism. Through rigorous, internationally benchmarked programs, we empower individuals and organizations to demonstrate verified excellence.",
    features: [
      { title: "Professional Certification", desc: "Accredited credentials for travel and tourism professionals at every career stage." },
      { title: "Organizational Quality Marks", desc: "Quality assurance certification for agencies, operators, and destinations." },
      { title: "Continuing Education", desc: "Ongoing professional development pathways to maintain and elevate standards." },
      { title: "Global Recognition", desc: "Credentials respected and recognized across international markets." },
    ],
  },
  "travel-awards": {
    ...SUBBRANDS[1],
    intro: "The Travel Awards celebrate the people, places, and organizations advancing the art of travel. Our independent, merit-based evaluation honors genuine excellence, innovation, and sustainable impact across the industry.",
    features: [
      { title: "Destination Excellence", desc: "Recognizing destinations that deliver exceptional visitor experiences." },
      { title: "Industry Innovation", desc: "Honoring breakthrough ideas reshaping the future of travel." },
      { title: "Service Distinction", desc: "Celebrating operators and professionals committed to outstanding service." },
      { title: "Sustainable Tourism", desc: "Rewarding leadership in responsible and regenerative tourism." },
    ],
  },
  "alfred-wine-ratings": {
    ...SUBBRANDS[3],
    intro: "Alfred Wine Ratings is an independent authority devoted to evaluating wines with integrity and expertise. Through transparent, palate-driven assessment, we celebrate quality and guide enthusiasts, collectors, and the trade toward genuine excellence.",
    features: [
      { title: "Independent Ratings", desc: "Unbiased, expert-led evaluation of wines from every region and category." },
      { title: "Quality Benchmarks", desc: "Clear, consistent scoring that defines distinction in the glass." },
      { title: "Tasting Expertise", desc: "Assessments grounded in rigorous, professional tasting methodology." },
      { title: "Trusted Recognition", desc: "Ratings respected by producers, sommeliers, and wine lovers alike." },
    ],
  },
  "vineyards-and-wine": {
    ...SUBBRANDS[4],
    intro: "Vineyards & Wine honors the heritage, artistry, and experiences behind the world's great wines. We celebrate the vineyards, wineries, and destinations that bring the culture of wine to discerning travelers everywhere.",
    features: [
      { title: "Exceptional Vineyards", desc: "Recognizing the world's most remarkable vineyards and estates." },
      { title: "Winery Experiences", desc: "Celebrating outstanding cellar-door and tasting experiences." },
      { title: "Wine Tourism", desc: "Connecting travelers with immersive wine destinations and routes." },
      { title: "Heritage & Craft", desc: "Honoring the tradition and craftsmanship of winemaking." },
    ],
  },
  "the-worlds-best-luxury": {
    ...SUBBRANDS[2],
    intro: "TWBL — The World's Best Luxury — is the authoritative recognition program for the finest in luxury travel. We identify and celebrate the hotels, resorts, and experiences that consistently set the global benchmark for refinement and service.",
    features: [
      { title: "Luxury Hotels & Resorts", desc: "Honoring the world's most exceptional luxury properties." },
      { title: "Signature Experiences", desc: "Recognizing extraordinary, curated guest experiences." },
      { title: "Culinary Excellence", desc: "Celebrating world-class dining within luxury hospitality." },
      { title: "Wellness & Spa", desc: "Distinguishing the finest wellness sanctuaries worldwide." },
    ],
  },
  "wttq-alliance": {
    ...SUBBRANDS[5],
    intro: "WTTQ Alliance identifies those hospitality businesses leading the way in making the world travel & tourism industry a world class sustainable business. We unite forward-thinking partners committed to measurable, lasting impact.",
    features: [
      { title: "Sustainability Leadership", desc: "Recognizing hospitality businesses setting the pace on sustainability." },
      { title: "Industry Collaboration", desc: "Connecting partners to advance shared standards and best practices." },
      { title: "World-Class Standards", desc: "Driving the industry toward world-class, responsible operations." },
      { title: "Lasting Impact", desc: "Championing measurable progress for people, places, and the planet." },
    ],
  },
};

export const WHAT_WE_DO = [
  { icon: "GraduationCap", title: "Education", desc: "Internationally recognized education and training programs that build expertise across the travel and tourism sector." },
  { icon: "Award", title: "Certification", desc: "Rigorous quality certification that validates professional competence and organizational excellence." },
  { icon: "FlaskConical", title: "Research", desc: "Industry research that informs best practices, benchmarks, and the future direction of travel." },
  { icon: "Lightbulb", title: "Innovation", desc: "Encouraging new ideas and approaches that elevate the standard of travel worldwide." },
  { icon: "Leaf", title: "Sustainable Tourism", desc: "Championing responsible tourism that protects destinations, communities, and the planet." },
  { icon: "Handshake", title: "Partnerships", desc: "Strategic international collaborations that strengthen the global travel community." },
];
